import type { ResolveFn } from '../types.js';

const oneRoll = (winsOn: (total: number) => boolean, ratio: number): ResolveFn => (b, roll) =>
  winsOn(roll.total)
    ? { betId: b.id, outcome: 'win', payout: b.amount * ratio }
    : { betId: b.id, outcome: 'lose', payout: 0 };

export const resolveAny7    = oneRoll((t) => t === 7, 4);
export const resolveYo      = oneRoll((t) => t === 11, 15);
export const resolveAceDeuce = oneRoll((t) => t === 3, 15);
export const resolveAces    = oneRoll((t) => t === 2, 30);
export const resolveBoxcars = oneRoll((t) => t === 12, 30);
export const resolveAnyCraps = oneRoll((t) => t === 2 || t === 3 || t === 12, 7);

export const resolveCAndE: ResolveFn = (b, roll) => {
  const half = Math.floor(b.amount / 2);
  const otherHalf = b.amount - half;
  if (roll.total === 2 || roll.total === 3 || roll.total === 12) {
    return { betId: b.id, outcome: 'win', payout: half * 7 - otherHalf };
  }
  if (roll.total === 11) {
    return { betId: b.id, outcome: 'win', payout: otherHalf * 15 - half };
  }
  return { betId: b.id, outcome: 'lose', payout: 0 };
};
